const AppLoading = () => {
  return (
    <div className="app-loading">
      <div className="app-loading__glow" />
      <div className="relative z-10 flex flex-col items-center gap-6 text-center">
        <div className="">
          <img
            src="/logos/logo.svg"
            alt="NxStart Logo"
            className="mx-auto h-[150px] w-auto"
          />
          <div className="flex flex-col items-center space-y-2">
            <p className="text-sm font-medium text-muted-foreground">
              Preparing your workspace
            </p>
            <div className="app-loading__bar">
              <span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLoading;
